import { OnInit, OnDestroy, Optional, Inject } from '@angular/core';
import { Component } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiContextUtils } from '@pershing/nxi-common';
declare let dojoApp: any;

@Component({
  selector: 'dojo-portfolio-composition',
  templateUrl: './dojo-portfolio-composition.component.html'
})
export class DojoPortfolioCompositionComponent implements OnInit, OnDestroy {
  inputValue: string = '';
  domain: string = '';
  subs: Subscription;
  isAdaTheme: boolean = false;
  acctRef: string;
  title: string;
  private qaInternalUrl: string;
  constructor(
    private contextService: IContextService,
    private translationService: PershingTranslationService,
    private paramService: NxiWidgetParamsService,
    private nxiRestService: NxiRestService,
    @Optional() @Inject('AppSettings') appSettings: any) {
    this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    this.qaInternalUrl = this.nxiRestService.serviceUrl;
    if (appSettings.themeType && appSettings.themeType === 'ada') {
      this.isAdaTheme = true;
      this.title = 'dojo-portfolio-composition';
    }
  }
  getWidgetResponse(acctresp: string): any {
    this.paramService.getWidgetParams(acctresp, 'portfolioComposition').subscribe(
      resp => {
        let response: any = resp.response;
        resp.response.storeUrl = this.qaInternalUrl + resp.response.storeUrl;
        resp.response.restUrl = this.qaInternalUrl + resp.response.restUrl;
        console.log('response', response);
        if (dojoApp) {
          dojoApp.renderPortfolioComposition(response);
        }
      },
      error => {
        console.log('error', error);
        return error;
      }
    );
  }

  getAdaWidgetResponse(acctresp: string): any {
    this.paramService.getWidgetParams(acctresp, 'portfolioCompositionAda').subscribe(
      resp => {
        resp.response.account = acctresp;
        let response: any = resp.response;
        console.log('response', response);
        if (dojoApp) {
          dojoApp.renderPortfolioCompositionAda(response);
        }
      },
      error => {
        console.log('error', error);
        return error;
      }
    );
  }

  ngOnInit() {
    this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
      let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
      this.inputValue = contextValue.inputValue;
      this.acctRef = contextValue.hashValue;
      if (this.inputValue !== '' && this.acctRef !== '') {
        if (this.isAdaTheme) {
          this.getAdaWidgetResponse(this.acctRef);
        } else {
          this.getWidgetResponse(this.acctRef);
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.unsubscribe();
    }
    if (dojoApp) {
      dojoApp.destroyWidget('PortfolioComposition');
    }
  }

}
